<template>
  <!-- eslint-disable vue/no-unused-refs -->
  <AppBarLayout>
    <template #default="{ activeHierarchy }">
      <div class="main">
        <BrandPattern4 ref="animation" page="APPBARLAYOUT" />
        <backgroundComponent />
        <ActivePathWrapper
          class="tw-px-[20px] md:tw-px-[32px] xl:tw-px-[79px]"
          :active-hierarchy="activeHierarchy"
        />
        <SetupWizardModal v-model:show="createAssessmentShow" />
      </div>
    </template>
  </AppBarLayout>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import SetupWizardModal from "@/components/wizard/setupWizardModal.vue";
import store from "@/store";

const isShowModal = computed(() => {
  return store.getters["SetupWizard/isShowModal"];
});

const createAssessmentShow = ref(isShowModal);
</script>
<style lang="scss" scoped>
.main {
  background: var(
    --ui-inner-shadow,
    linear-gradient(180deg, rgba(237, 237, 237, 0.6) 0%, #f3f4f5 56.15%)
  );
  width: 100%;
  height: 100%;
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;

  .main-content {
    padding: 94px 79px 100px;

    @media (max-width: 1199px) {
      padding: 94px 32px 60px;

      @media (max-width: 991px) {
        padding: 94px 20px 60px;
      }
    }

    @media (max-width: 767px) {
      padding: 94px 10px 60px;
    }
  }
}
</style>
